import { styled, Box } from "@mui/system";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#B6B4B3",
    ...theme.applyStyles("dark", {
      backgroundColor: "#B6B4B3",
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#000000",
    ...theme.applyStyles("dark", {
      backgroundColor: "#000000",
    }),
  },
}));

export const TopicsBox = styled(Box)(() => ({
  padding: "6rem",
  // width: "500px",
  // display: "flex",
  // justifyContent: "center",
  // marginLeft: "30px",
  // maxHeight: "1100px",
  // [`& .css-dasnyc-MuiImageListItemBar-title`]: {
  //   fontWeight: "bold",
  //   fontSize: "1.2rem",
  // },
  // [`$ .MuiImageListItemBar-subtitle`]: {
  //   fontSize: "1rem",
  // },
}));
